/**
 * @descreiption Changes the labels position
 * @param {Object} newsize  - {width,height} the ammount to increment the current position by
 * @param {Array} labels - the labels that need to be moved
 */
export function changeLabelsPosition(newsize, labels) {
    for (let i = 0; i < labels.length; i++) {
        labels[i].labelPosition.x += newsize.width;
        labels[i].labelPosition.y += newsize.height;
    }
}
